export enum GetStartedTaskId {
    SendAnEmail = 'SendAnEmail',
    DownloadMobile = 'DownloadMobile',
    PremiumUpsell = 'PremiumUpsell',
    ImportContact = 'ImportContact',
    ConfirmTimeZone = 'ConfirmTimeZone',
    ShowOfficeApps = 'ShowOfficeApps',
    AddStorageAccount = 'ConnectStorageAccount',
    CustomizeTheLook = 'CustomizeTheLook',
}
